export const apiEndPoints = {
  login: "/auth/login",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  changePassword: "/auth/change-password",
  users: "/users",
  transactions: "/transactions",
  investors: "/investors",
  getStates: "/states",
  logout: "/auth/logout",
  create1099Summary: "reports/1099",
  accounts: "/accounts",
  partnerships: "/partnerships",
  settings: "/settings",
  welcomeBanner: "/settings/welcome-banner",
  distributions: "/distributions",
  process: "/processes/monthend",
  latestProcess: "/processes/monthend/latest",
  check: "check",
  ach: "ach",
  loanSummary: "reports/loan",
  investmentSummary: "reports/investment",
  clientDetails: "/client-detail",
  emailLogs: "/logs/email",
  auditLogs: "/logs/audit",
  downloadForm1096: "reports/1096",
  getOutOfBalance: "reports/out-of-balance",
  getCashAccountStatement: "reports/cash-account-statement"
};
